import type {IntlShape, MessageDescriptor} from "react-intl";
import type {TFunction} from "i18next";
import type {I18nValues, LocalizedLike, LocalizedString, LocalizedToken} from "./i18n-types";

export function toReactIntlDescriptor(loc: LocalizedString | LocalizedToken): MessageDescriptor {
  return {
    id: loc.id,
    defaultMessage: "defaultMessage" in loc ? loc.defaultMessage : undefined,
    description: loc.description,
  };
}

export function formatWithReactIntl(
  intl: IntlShape,
  loc: LocalizedString | LocalizedToken,
  values?: I18nValues
): string {
  const descriptor = toReactIntlDescriptor(loc);

  const mergedValues = values ?? ("values" in loc ? loc.values : undefined);

  return intl.formatMessage(descriptor, mergedValues as any);
}

export function translateWithI18next(
  t: TFunction,
  loc: LocalizedString | LocalizedToken,
  values?: I18nValues
): string {
  const mergedValues = values ?? ("values" in loc ? loc.values : undefined);

  return t(loc.id, {
    defaultValue: "defaultMessage" in loc ? loc.defaultMessage : undefined,
    ...(mergedValues ?? {}),
  });
}

export function resolveLocalizedWithIntl(
  intl: IntlShape,
  loc: LocalizedLike,
  values?: I18nValues
): string {
  if (typeof loc === "string") return loc;
  return formatWithReactIntl(intl, loc, values);
}

export function resolveLocalizedWithI18next(
  t: TFunction,
  loc: LocalizedLike,
  values?: I18nValues
): string {
  if (typeof loc === "string") return loc;
  return translateWithI18next(t, loc, values);
}
